
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { list_type, record_type, bool_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { filter, map, contains, singleton, tryFind, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { safeHash, equals } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

export class NotificationChannel extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Mail", "Push", "BrowserPush"];
    }
}

export function NotificationChannel_$reflection() {
    return union_type("Shared.NotificationSettings.NotificationChannel", [], NotificationChannel, () => [[], [], []]);
}

export const NotificationChannelModule_all = ofArray([new NotificationChannel(0, []), new NotificationChannel(1, []), new NotificationChannel(2, [])]);

export function NotificationChannelModule_key(channel) {
    switch (channel.tag) {
        case 1:
            return "push";
        case 2:
            return "browser_push";
        default:
            return "mail";
    }
}

export function NotificationChannelModule_ofKey(value) {
    return tryFind((channel) => (NotificationChannelModule_key(channel) === value), NotificationChannelModule_all);
}

export class NotificationArea extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Assignments", "Reservations", "Stock", "Dates", "ProblemReports", "Chat", "Stocktaking"];
    }
}

export function NotificationArea_$reflection() {
    return union_type("Shared.NotificationSettings.NotificationArea", [], NotificationArea, () => [[], [], [], [], [], [], []]);
}

export const NotificationAreaModule_all = ofArray([new NotificationArea(0, []), new NotificationArea(1, []), new NotificationArea(2, []), new NotificationArea(3, []), new NotificationArea(4, []), new NotificationArea(5, []), new NotificationArea(6, [])]);

export function NotificationAreaModule_key(area) {
    switch (area.tag) {
        case 1:
            return "reservations";
        case 2:
            return "stock";
        case 3:
            return "dates";
        case 4:
            return "problem_reports";
        case 5:
            return "chat";
        case 6:
            return "stocktaking";
        default:
            return "assignments";
    }
}

export class NotificationMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AssignmentReceived", "AssignmentReturned", "OpenAssignmentReminder", "Reservation", "AssignedInventoryReservation", "CategoryMinimumStock", "ToolWithQuantityMinimumStock", "ConsumableMinimumStock", "ReleaseDate", "DateReminder", "InspectionReminder", "ReturnReminder", "ReturnOverdue", "MonthlyForecast", "ProblemReport", "ChatMessage", "StocktakingListAssigned", "StocktakingStarted", "StocktakingCountReminder", "StocktakingCountOverdue", "StocktakingListCompleted", "StocktakingReadyForReview", "StocktakingCompleted", "StocktakingResponsibleAdded"];
    }
}

export function NotificationMessage_$reflection() {
    return union_type("Shared.NotificationSettings.NotificationMessage", [], NotificationMessage, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export const NotificationMessageModule_all = ofArray([new NotificationMessage(0, []), new NotificationMessage(1, []), new NotificationMessage(2, []), new NotificationMessage(3, []), new NotificationMessage(4, []), new NotificationMessage(5, []), new NotificationMessage(6, []), new NotificationMessage(7, []), new NotificationMessage(8, []), new NotificationMessage(9, []), new NotificationMessage(10, []), new NotificationMessage(11, []), new NotificationMessage(12, []), new NotificationMessage(13, []), new NotificationMessage(14, []), new NotificationMessage(15, []), new NotificationMessage(16, []), new NotificationMessage(17, []), new NotificationMessage(18, []), new NotificationMessage(19, []), new NotificationMessage(20, []), new NotificationMessage(21, []), new NotificationMessage(22, []), new NotificationMessage(23, [])]);

export function NotificationMessageModule_key(message) {
    switch (message.tag) {
        case 1:
            return "assignment_returned";
        case 2:
            return "open_assignment_reminder";
        case 3:
            return "reservation";
        case 4:
            return "assigned_inventory_reservation";
        case 5:
            return "category_minimum_stock";
        case 6:
            return "tool_with_quantity_minimum_stock";
        case 7:
            return "consumable_minimum_stock";
        case 8:
            return "release_date";
        case 9:
            return "date_reminder";
        case 10:
            return "inspection_reminder";
        case 11:
            return "return_reminder";
        case 12:
            return "return_overdue";
        case 13:
            return "monthly_forecast";
        case 14:
            return "problem_report";
        case 15:
            return "chat_message";
        case 16:
            return "stocktaking_list_assigned";
        case 17:
            return "stocktaking_started";
        case 18:
            return "stocktaking_count_reminder";
        case 19:
            return "stocktaking_count_overdue";
        case 20:
            return "stocktaking_list_completed";
        case 21:
            return "stocktaking_ready_for_review";
        case 22:
            return "stocktaking_completed";
        case 23:
            return "stocktaking_responsible_added";
        default:
            return "assignment_received";
    }
}

export function NotificationMessageModule_ofKey(value) {
    return tryFind((message) => (NotificationMessageModule_key(message) === value), NotificationMessageModule_all);
}

export function NotificationMessageModule_area(message) {
    switch (message.tag) {
        case 3:
        case 4:
            return new NotificationArea(1, []);
        case 5:
        case 6:
        case 7:
        case 8:
            return new NotificationArea(2, []);
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
            return new NotificationArea(3, []);
        case 14:
            return new NotificationArea(4, []);
        case 15:
            return new NotificationArea(5, []);
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 21:
        case 22:
        case 23:
            return new NotificationArea(6, []);
        default:
            return new NotificationArea(0, []);
    }
}

export function NotificationMessageModule_channels(message) {
    switch (message.tag) {
        case 1:
        case 12:
        case 15:
            return ofArray([new NotificationChannel(1, []), new NotificationChannel(2, [])]);
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 13:
        case 22:
            return singleton(new NotificationChannel(0, []));
        default:
            return ofArray([new NotificationChannel(0, []), new NotificationChannel(1, []), new NotificationChannel(2, [])]);
    }
}

export function NotificationMessageModule_isAvailable(message, channel) {
    return contains(channel, NotificationMessageModule_channels(message), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    });
}

export function NotificationMessageModule_defaultEnabled(message, channel) {
    let matchResult;
    switch (message.tag) {
        case 0: {
            switch (channel.tag) {
                case 0: {
                    matchResult = 0;
                    break;
                }
                case 2: {
                    matchResult = 1;
                    break;
                }
                default:
                    matchResult = 2;
            }
            break;
        }
        case 13: {
            switch (channel.tag) {
                case 0: {
                    matchResult = 0;
                    break;
                }
                case 2: {
                    matchResult = 1;
                    break;
                }
                default:
                    matchResult = 2;
            }
            break;
        }
        case 20: {
            switch (channel.tag) {
                case 0: {
                    matchResult = 0;
                    break;
                }
                case 2: {
                    matchResult = 1;
                    break;
                }
                default:
                    matchResult = 2;
            }
            break;
        }
        default:
            if (channel.tag === 2) {
                matchResult = 1;
            }
            else {
                matchResult = 2;
            }
    }
    switch (matchResult) {
        case 0:
            return false;
        case 1:
            return false;
        default:
            return NotificationMessageModule_isAvailable(message, channel);
    }
}

export const NotificationMessageModule_byArea = map((areaOfGroup) => [areaOfGroup, filter((message) => equals(NotificationMessageModule_area(message), areaOfGroup), NotificationMessageModule_all)], NotificationAreaModule_all);

export class NotificationChannelMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Optional", "Locked", "Required"];
    }
}

export function NotificationChannelMode_$reflection() {
    return union_type("Shared.NotificationSettings.NotificationChannelMode", [], NotificationChannelMode, () => [[], [], []]);
}

export const NotificationChannelModeModule_all = ofArray([new NotificationChannelMode(0, []), new NotificationChannelMode(1, []), new NotificationChannelMode(2, [])]);

export function NotificationChannelModeModule_key(mode) {
    switch (mode.tag) {
        case 1:
            return "locked";
        case 2:
            return "required";
        default:
            return "optional";
    }
}

export function NotificationChannelModeModule_ofKey(value) {
    return tryFind((mode) => (NotificationChannelModeModule_key(mode) === value), NotificationChannelModeModule_all);
}

export class CustomerNotificationSetting extends Record {
    constructor(Message, Channel, DefaultEnabled, Mode) {
        super();
        this.Message = Message;
        this.Channel = Channel;
        this.DefaultEnabled = DefaultEnabled;
        this.Mode = Mode;
    }
}

export function CustomerNotificationSetting_$reflection() {
    return record_type("Shared.NotificationSettings.CustomerNotificationSetting", [], CustomerNotificationSetting, () => [["Message", NotificationMessage_$reflection()], ["Channel", NotificationChannel_$reflection()], ["DefaultEnabled", bool_type], ["Mode", NotificationChannelMode_$reflection()]]);
}

export class UserNotificationChoice extends Record {
    constructor(Message, Channel, Enabled) {
        super();
        this.Message = Message;
        this.Channel = Channel;
        this.Enabled = Enabled;
    }
}

export function UserNotificationChoice_$reflection() {
    return record_type("Shared.NotificationSettings.UserNotificationChoice", [], UserNotificationChoice, () => [["Message", NotificationMessage_$reflection()], ["Channel", NotificationChannel_$reflection()], ["Enabled", bool_type]]);
}

export class NotificationSettingCell extends Record {
    constructor(Message, Channel, Available, Enabled, Mode, Effective) {
        super();
        this.Message = Message;
        this.Channel = Channel;
        this.Available = Available;
        this.Enabled = Enabled;
        this.Mode = Mode;
        this.Effective = Effective;
    }
}

export function NotificationSettingCell_$reflection() {
    return record_type("Shared.NotificationSettings.NotificationSettingCell", [], NotificationSettingCell, () => [["Message", NotificationMessage_$reflection()], ["Channel", NotificationChannel_$reflection()], ["Available", bool_type], ["Enabled", bool_type], ["Mode", NotificationChannelMode_$reflection()], ["Effective", bool_type]]);
}

export class UserNotificationSettingsDto extends Record {
    constructor(Cells, MailAllowedByRole) {
        super();
        this.Cells = Cells;
        this.MailAllowedByRole = MailAllowedByRole;
    }
}

export function UserNotificationSettingsDto_$reflection() {
    return record_type("Shared.NotificationSettings.UserNotificationSettingsDto", [], UserNotificationSettingsDto, () => [["Cells", list_type(NotificationSettingCell_$reflection())], ["MailAllowedByRole", bool_type]]);
}

export class UpdateUserNotificationSettingsDto extends Record {
    constructor(Choices) {
        super();
        this.Choices = Choices;
    }
}

export function UpdateUserNotificationSettingsDto_$reflection() {
    return record_type("Shared.NotificationSettings.UpdateUserNotificationSettingsDto", [], UpdateUserNotificationSettingsDto, () => [["Choices", list_type(UserNotificationChoice_$reflection())]]);
}

export class CustomerNotificationSettingsDto extends Record {
    constructor(Settings) {
        super();
        this.Settings = Settings;
    }
}

export function CustomerNotificationSettingsDto_$reflection() {
    return record_type("Shared.NotificationSettings.CustomerNotificationSettingsDto", [], CustomerNotificationSettingsDto, () => [["Settings", list_type(CustomerNotificationSetting_$reflection())]]);
}

export class UpdateCustomerNotificationSettingsDto extends Record {
    constructor(Settings) {
        super();
        this.Settings = Settings;
    }
}

export function UpdateCustomerNotificationSettingsDto_$reflection() {
    return record_type("Shared.NotificationSettings.UpdateCustomerNotificationSettingsDto", [], UpdateCustomerNotificationSettingsDto, () => [["Settings", list_type(CustomerNotificationSetting_$reflection())]]);
}

